import { render, staticRenderFns } from "./RateioTabela.vue?vue&type=template&id=1bdf7408"
import script from "./RateioTabela.vue?vue&type=script&lang=js"
export * from "./RateioTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports